'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const skeleton_style = require('./skeleton.style.js');

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getLoadingClassName = function getLoadingClassName(className, isLoading) {
  var temp = [className];

  if (isLoading) {
    temp.push('is-loading');
  }

  return temp.join(' ');
};

var Skeleton = function Skeleton(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100%' : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? 5 : _ref$borderRadius,
      _ref$isCircle = _ref.isCircle,
      isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle,
      _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? true : _ref$animation,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? {} : _ref$theme,
      isLoading = _ref.isLoading,
      children = _ref.children,
      className = _ref.className,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 5 : _ref$margin,
      _ref$count = _ref.count,
      count = _ref$count === void 0 ? 1 : _ref$count;
  var skeletonArr = [];
  var completeProps = {
    height: height,
    width: width,
    borderRadius: borderRadius,
    animation: animation,
    isCircle: isCircle,
    theme: theme,
    children: children,
    className: className,
    margin: margin,
    count: count,
    isLoading: isLoading
  };

  for (var i = 0; i < count; i++) {
    var skeletonItemId = "skeleton-item-".concat(i);

    if (typeof isLoading !== 'undefined') {
      var completePropsNew = _objectSpread(_objectSpread({}, completeProps), {}, {
        className: getLoadingClassName(className, isLoading)
      });

      skeletonArr.push( /*#__PURE__*/React__default.createElement(skeleton_style.StyledBaseSkeleton, _extends({}, completePropsNew, {
        key: skeletonItemId
      }), /*#__PURE__*/React__default.createElement("span", null, children)));
    } else {
      skeletonArr.push( /*#__PURE__*/React__default.createElement(skeleton_style.StyledBaseSkeleton, _extends({}, completeProps, {
        key: skeletonItemId
      })));
    }
  }

  return /*#__PURE__*/React__default.createElement(React.Fragment, null, skeletonArr);
};

const Skeleton$1 = styled.withTheme(Skeleton);

module.exports = Skeleton$1;
